export default __webpack_public_path__ + "static/small_rectangle_shadow_jtb-015acbdfe4bdff139c7a120e0532b1fc.gif";